import { DataRouter } from 'react-router';

/**
 * Holds the application's router so hooks can read and navigate the location without subscribing to it.
 * They cannot import it from routes.tsx: routes imports the pages that use those hooks, and the resulting
 * import cycle leaves modules uninitialized at load.
 */
let routerInstance: DataRouter | undefined;

export function setRouterInstance(router: DataRouter) {
	routerInstance = router;
}

/**
 * Method to return the concrete router instance
 */
export function getRouterInstance(): DataRouter {
	if (!routerInstance) {
		throw new Error('Router has not been instantiated.');
	}

	return routerInstance;
}
